export default class Marquee {
  constructor({
    cssClass,
    direction,
    slidesPerView = "auto",
    speed = 3500,
    spaceBetween = 160,
  }) {
    this.cssClass = cssClass;
    this.direction = direction;
    this.slidesPerView = slidesPerView;
    this.speed = speed;
    this.spaceBetween = spaceBetween;
    this.swiper = null;
  }

  init() {
    this.swiper = new Swiper(this.cssClass, {
      slidesPerView: this.slidesPerView,
      spaceBetween: this.spaceBetween,
      loop: true,
      speed: this.speed,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: this.direction === MarqueeDirections.rightToLeft,
      },
    });
  }
}

export const MarqueeDirections = {
  leftToRight: "left-right",
  rightToLeft: "right-left",
};
